import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Image } from '@/shared/ui/image';
const DrawerContainer = styled.div`
  position: fixed;
  bottom: ${({ $isOpen }) => ($isOpen ? 0 : '-10000px')};
  left: 0;
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  background-color: #fff;
  transition: bottom 0.3s ease;
  box-shadow: 0px -5px 10px rgba(0, 0, 0, 0.5);
  z-index: 100;
  border-radius: 20px 20px 0px 0px;
  background: #131315;
  padding-bottom: 16px;
  backdrop-filter: blur(10px);
`;

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: ${({ $isOpen }) => ($isOpen ? 'block' : 'none')};
  z-index: 99;
`;
export const DrawerContent = styled.div`
  position: relative;
  height: 100%;
`;
export const ImageWrapper = styled.div`
  position: absolute;
  width: 20px;
  height: 20px;
  right: 24px;
  top: 16px;
  z-index: 10;
`;

const Drawer = ({
  children,
  isOpen: propsIsOpen,
  onClose,
  isCategory = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    setIsOpen(propsIsOpen);
  }, [propsIsOpen]);

  useEffect(() => {
    if (isOpen) {
      window.document.body.style.overflow = 'hidden';
    }
    return () => {
      window.document.body.style.overflow = 'visible';
    };
  }, [isOpen]);

  const toggleDrawer = () => {
    setIsOpen(!isOpen);
    if (onClose) {
      onClose(!isOpen);
    }
  };

  return (
    <>
      <DrawerContainer $isOpen={isOpen}>
        <DrawerContent>
          <ImageWrapper onClick={onClose}>
            <Image
              style={{ cursor: 'pointer' }}
              width={32}
              height={32}
              alt="close-icon"
              src="/images/icons/close-dialog.svg"
            />
          </ImageWrapper>

          {children}
        </DrawerContent>
      </DrawerContainer>
      {/* <Overlay $isOpen={isOpen} onClick={toggleDrawer} /> */}
    </>
  );
};

export { Drawer };
